import { appAxiosInstance } from '@/config/axios';

import { transformKeysSnakeToCamelCase } from '@/utils/transformation';

import type {
	CareersData,
	CheckPageEditAccessPayload,
	CheckPageEditAccessResponse,
	EditPagePayload,
} from '../types/careers-types';

export async function fetchCareersData(
	handle: string,
	options?: { revalidateSeconds?: number }
): Promise<CareersData | null> {
	const apiUrl = process.env.NEXT_PUBLIC_API_ENDPOINT_V1;

	try {
		const res = await fetch(`${apiUrl}/page/fetch-published-forms`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ handle }),
			...(options?.revalidateSeconds
				? { next: { revalidate: options.revalidateSeconds } }
				: { cache: 'no-store' }),
		});

		// Handle not found - invalid handle (404 or 400)
		if (res.status === 404 || res.status === 400) {
			return null;
		}

		if (!res.ok) {
			throw new Error('Failed to fetch');
		}

		const data = await res.json();

		// If API returns error in response body
		if (data.error || data.success === false) {
			return null;
		}

		return transformKeysSnakeToCamelCase(data) as CareersData;
	} catch (err) {
		console.error('[Careers] Fetch error:', err);
		throw new Error('Failed to fetch');
	}
}

export async function fetchCareersDataClientSide(handle: string): Promise<CareersData> {
	const response = await appAxiosInstance.post('/page/fetch-published-forms', { handle });
	return transformKeysSnakeToCamelCase(response.data) as CareersData;
}

export async function checkPageEditAccess(
	payload: CheckPageEditAccessPayload
): Promise<CheckPageEditAccessResponse> {
	const response = await appAxiosInstance.post('/page/check-edit-access', payload);
	return transformKeysSnakeToCamelCase(response.data) as unknown as CheckPageEditAccessResponse;
}

export async function editCareersPage(payload: EditPagePayload): Promise<void> {
	await appAxiosInstance.post('/page/edit', payload);
}
